import * as BuildingPlans from "../../../ApartmentFinderConfig/BuildingPlans"
import { colours } from "../../../ApartmentFinderConfig/colours"
import { useCallback, useRef, useLayoutEffect } from "react"
import { useStore } from "../State/Store"
import { hasNumber } from "../Utils/Helpers"
import {
  blockIsAvailable,
  getNestedObject,
  getShapes,
  returnSVGID,
  useAvailableApartments,
  UseSvg
} from "../Utils/hooks"
import { blockInfo } from "../../../ApartmentFinderConfig/blockInfo"
import { BuildingElevationComponent } from "../../../ApartmentFinderConfig/BuildingElevations"

const availableBlocks = Object.keys(blockInfo)

function SitePlan() {
  const svgref = useRef()
  const setActivateBlock = useStore(state => state.setActivateBlock)
  const favouritesActive = useStore(state => state.favouritesActive)
  const setCurrentCameraPositionID = useStore(
    state => state.setCurrentCameraPositionID
  )
  const bathroomCounts = useStore(state => state.bathroomCounts)
  const bedroomCounts = useStore(state => state.bedroomCounts)
  const aspects = useStore(state => state.aspects)

  const storredObjects = {
    ID: useAvailableApartments().map(obj => obj.PlotNumberPlanning)
  }

  const handleClick = e => {
    let target = returnSVGID(
      e.target.parentElement.parentElement.parentElement.id,
      1
    )
    if (blockIsAvailable(target)) {
      setCurrentCameraPositionID(`block${target.toUpperCase()}`)
      setActivateBlock(target)
    }
  }

  useLayoutEffect(() => {
    const all = UseSvg(svgref.current.children, "")
    const buttons = UseSvg(svgref.current.children, "hidden_buttons")
    const iconType2 = UseSvg(svgref.current.children, "icon-type-2")
    const iconType1 = UseSvg(svgref.current.children, "icon-type-1")
    const apt_no = getNestedObject(svgref.current.children, "apt_no_")
    const buildings = getNestedObject(svgref.current.children, "building")
    const greenSpace = getNestedObject(svgref.current.children, "green_space")
    const text = getNestedObject(svgref.current.children, "text")
    const textType2 = getNestedObject(svgref.current.children, "text-type-2")

    //**  All */
    all.map(c => (c.style.cursor = "pointer"))
    all.map(c => (c.style.userSelect = "none"))

    //**  All Text */
    getShapes(text).map(c => (c.style.fill = colours.primaryUI))
    getShapes(text).map(shape =>
      shape.setAttribute("stroke", colours.primaryUI)
    )
    getShapes(text).map(shape => shape.setAttribute("stroke-width", 0))

    //**  Label Text */
    getShapes(textType2).map(c => (c.style.fill = colours.secondaryUI))
    getShapes(textType2).map(shape =>
      shape.setAttribute("stroke", colours.primaryUI)
    )
    getShapes(textType2).map(c => c.setAttribute("text-anchor", "left"))
    // getShapes(textType2).map(c => c.setAttribute("text-align", "center"))
    getShapes(textType2).map(c => c.setAttribute("border", "red solid 1px"))
    // textType2.map(shape => console.log(shape.parentElement.width))

    //**  Label Icon */
    getShapes(iconType2).map(c => (c.style.fill = colours.primaryUILighter))
    getShapes(iconType2).map(shape =>
      shape.setAttribute("stroke", colours.primaryUI)
    )
    getShapes(iconType2).map(shape => shape.setAttribute("stroke-width", 0))

    //**  Buildings */
    buildings.map(c => (c.style.fillOpacity = 0))
    getShapes(buildings).map(shape => shape.setAttribute("stroke-width", 2.5))
    getShapes(buildings).map(shape =>
      shape.setAttribute("stroke", colours.primaryUI)
    )
    //**  GreenSpace */
    getShapes(greenSpace).map(shape =>
      shape.setAttribute("stroke", colours.greenSpace)
    )
    getShapes(greenSpace).map(shape =>
      shape.setAttribute("fill", colours.greenSpace)
    )
    //**  Invisible buttons */
    buttons.map(c => (c.style.opacity = 0))
    buttons.map(c => (c.onclick = e => handleClick(e)))

    //**  Button Icons */
    getShapes(iconType1).map(c => c.setAttribute("fill", "none"))
    getShapes(iconType1).map(c =>
      c.setAttribute("stroke", colours.primaryUILight)
    )
    // getShapes(iconType1).map(c => (c.onclick = e => console.log("object")))

    getShapes(iconType1).map(c => (c.style.stroke = colours.secondaryUI))
    getShapes(iconType1).map(shape =>
      shape.setAttribute("stroke", colours.primaryUILight)
    )

    //**  Apartment Numbers */
    apt_no.map(c => c.setAttribute("text-align", "center"))
    getShapes(apt_no).map(c => c.setAttribute("fill", colours.primaryUI))
    getShapes(apt_no).map(c => c.setAttribute("stroke", colours.primaryUI))
    // getShapes(apt_no).map(c => c.setAttribute("stroke-weight", 0))
    getShapes(apt_no).map(c => c.setAttribute("text-anchor", "right"))

    apt_no.map(
      c =>
        (c.lastChild.textContent = storredObjects.ID.filter(i =>
          i.includes(returnSVGID(c.id, 2))
        ).length)
    )
  }, [bedroomCounts, favouritesActive, aspects, bathroomCounts, storredObjects])

  return <BuildingPlans.SvgSitePlan ref={svgref} />
}

function SvgJSX({ isCard }) {
  const activeBlock = useStore(state => state.activeBlock)
  const apartmentFinderActive = useStore(state => state.apartmentFinderActive)

  if (!isCard) {
    if (activeBlock && apartmentFinderActive) {
      if (hasNumber(activeBlock)) {
        return <ElevationSvgJsx activeBlock={activeBlock} />
      } else return <CorePlanSvgJsx> noblock</CorePlanSvgJsx>
    } else return <SitePlan />
  } else return <ElevationSvgJsx activeBlock={activeBlock} isCard={isCard} />
}

//** CORE PLAN SVG */
export function CorePlanSvgJsx() {
  const svgref = useRef()
  const activeBlock = useStore(state => state.activeBlock)
  const bathroomCounts = useStore(state => state.bathroomCounts)
  const aspects = useStore(state => state.aspects)
  const setActivateBlock = useStore(state => state.setActivateBlock)
  const setActiveFloors = useStore(state => state.setActiveFloors)
  const bedroomCounts = useStore(state => state.bedroomCounts)
  const setCurrentCameraPositionID = useStore(
    state => state.setCurrentCameraPositionID
  )

  let arr = Object.values(useAvailableApartments())

  const checkAvailableAptInBlock = id => {
    let temp = arr.filter(a => a.PlotNumberPlanning.split(".")[0].includes(id))
    return temp.length
  }

  const handleClick = e => {
    let targetID = returnSVGID(e.target.id, 2)
    if (availableBlocks.includes(targetID)) {
      setActivateBlock(targetID)
      setCurrentCameraPositionID(`building${targetID.toUpperCase()}`)
      setActiveFloors(blockInfo[targetID].totalFloors + 1)
    }
  }

  useLayoutEffect(() => {
    const all = UseSvg(svgref.current.children, "")
    const buttons = UseSvg(svgref.current.children, "building_button")
    const icons = UseSvg(svgref.current.children, "icon")
    const apt_no = getNestedObject(svgref.current.children, "apt_no_")
    const buildings = getNestedObject(svgref.current.children, "building")
    const greenSpace = getNestedObject(svgref.current.children, "green_space")
    const text = getNestedObject(svgref.current.children, "text")

    //**  All */
    all.map(c => (c.style.cursor = "pointer"))
    all.map(c => (c.style.userSelect = "none"))

    //**  All Text */
    getShapes(text).map(c => (c.style.fill = colours.primaryUI))
    getShapes(text).map(shape =>
      shape.setAttribute("stroke", colours.primaryUI)
    )

    //**  Buildings */
    buildings.map(c => (c.style.fillOpacity = 0))
    getShapes(buildings).map(shape => shape.setAttribute("stroke-width", 2.5))
    getShapes(buildings).map(shape =>
      shape.setAttribute("stroke", colours.primaryUI)
    )
    //**  GreenSpace */
    getShapes(greenSpace).map(shape =>
      shape.setAttribute("stroke", colours.greenSpace)
    )
    getShapes(greenSpace).map(shape =>
      shape.setAttribute("fill", colours.greenSpace)
    )
    //**  Invisible buttons */
    buttons.map(c => (c.style.opacity = 0))
    buttons.map(c => (c.onclick = e => handleClick(e)))

    //**  Button Icons */
    getShapes(icons).map(c => c.setAttribute("fill", colours.secondaryUI))
    getShapes(icons).map(c => c.setAttribute("stroke", colours.secondaryUI))
    getShapes(icons).map(c => (c.style.stroke = colours.secondaryUI))
    getShapes(icons).map(shape =>
      shape.setAttribute("stroke", colours.secondaryUI)
    )

    // console.log(Object.keys(blockInfo))

    apt_no.map(
      c => (c.textContent = checkAvailableAptInBlock(returnSVGID(c.id, 2)))
    )

    apt_no.map(
      c =>
        (c.style.display =
          Object.keys(blockInfo).filter(a => a.includes(returnSVGID(c.id, 2)))
            .length > 0
            ? ""
            : "none")
    )

    // apt_no.map(c =>

    //     Object.keys(blockInfo).filter(a => a.includes(returnSVGID(c.id, 2)))
    //       .length > 0

    // )
  }, [bedroomCounts, bathroomCounts, aspects])
  // console.log(activeBlock)

  return (
    <BuildingPlans.BlockPlanComponenet blockID={activeBlock} ref={svgref} />
  )
}

/////////////////////////////////////////////////////////////

export function ElevationSvgJsx({ isCard, staticActiveBlock }) {
  const svgref = useRef()
  const returnFloorNumber = id => {
    return Number(id.split("_")[2])
  }

  if (!isCard) {
  }

  const storredObjects = {
    ID: useAvailableApartments().map(obj => obj.PlotNumberPlanning)
  }

  const checkAvailableAptOnFloor = (floorNo, buildingID) => {
    return storredObjects.ID.filter(
      obj =>
        Number(obj.split(".")[1]) === floorNo &&
        obj.split(".")[0] === buildingID
    ).length
  }

  const filterHabitable = arr => {
    return arr.filter(e => isHabitable(e.id))
  }

  const isHabitable = v => {
    return (
      blockInfo[activeBlock].habitableFloors.includes(returnFloorNumber(v)) ||
      isNaN(returnFloorNumber(v))
    )
  }

  const selectedFavourite = useStore(state => state.selectedFavourite)
  const activeBlock = useStore(state => state.activeBlock)
  const bedroomCounts = useStore(state => state.bedroomCounts)
  const bathroomCounts = useStore(state => state.bathroomCounts)
  const activeFloor = useStore(state => state.activeFloor)
  const setActiveFloors = useStore(state => state.setActiveFloors)
  const activeApt = useStore(state => state.activeApt)
  const aspects = useStore(state => state.aspects)
  const handleFloorClick = useCallback(
    v => {
      isNaN(returnSVGID(v.target.id, 2))
        ? setActiveFloors(blockInfo[activeBlock].numberOfFloors)
        : setActiveFloors(returnFloorNumber(v.target.id))
    },
    [setActiveFloors]
  )

  useLayoutEffect(() => {
    let floor_buttons = getNestedObject(svgref.current.children, "floor_button")
    let floor_no = getNestedObject(svgref.current.children, "floor_no")
    let apt_no = getNestedObject(svgref.current.children, "apt_no")
    let apt_circle = getNestedObject(svgref.current.children, "apt_circle")
    let floor_circle = getNestedObject(svgref.current.children, "floor_circle")

    //**Floor Circle */
    floor_circle.map(c => c.setAttribute("fill", colours.secondaryUI))

    //**Apartment Circle */
    apt_circle.map(c => c.setAttribute("fill", colours.primaryUILighter))
    apt_circle.map(c => (c.style.display = "none"))
    apt_circle = filterHabitable(apt_circle)
    apt_circle.map(c => (c.style.display = ""))
    //**Apartment Number */
    apt_no.map(c => c.setAttribute("fill", colours.secondaryUI))
    apt_no.map(c => (c.style.cursor = "auto"))
    apt_no.map(c => (c.style.userSelect = "none"))
    apt_no.map(c => (c.style.display = "none"))
    apt_no = filterHabitable(apt_no)
    apt_no.map(c => (c.style.display = ""))
    //**floor number */
    floor_no.map(c => c.setAttribute("fill", colours.primaryUILighter))
    floor_no.map(c => (c.style.cursor = "auto"))
    floor_no.map(c => (c.style.userSelect = "none"))

    //**Apartment Circle */
    floor_buttons.map(c => (c.style.display = "none"))
    floor_buttons = floor_buttons.filter(a => isHabitable(a.id))
    floor_buttons.map(c => (c.style.display = ""))
    floor_buttons.map(c => (c.style.cursor = "pointer"))
    floor_buttons.map(c => (c.style.userSelect = "none"))

    // ** Floor Buttons */
    floor_buttons.map(fb =>
      fb.setAttribute(
        "fill",
        returnFloorNumber(fb.id) === Number(activeFloor)
          ? colours.primaryUILight
          : colours.primaryUILighter
      )
    )
    floor_buttons.map(fb =>
      fb.setAttribute(
        "opacity",
        isNaN(returnFloorNumber(fb.id)) ||
          checkAvailableAptOnFloor(returnFloorNumber(fb.id), activeBlock) === 0
          ? 0
          : returnFloorNumber(fb.id) === Number(activeFloor)
          ? 1
          : 0.4
      )
    )

    //** Interactions */
    apt_no.map(
      c =>
        (c.lastChild.textContent = checkAvailableAptOnFloor(
          returnFloorNumber(c.id),
          activeBlock
        ))
    )
    floor_buttons.map(fb =>
      checkAvailableAptOnFloor(returnFloorNumber(fb.id), activeBlock) > 0
        ? (fb.onclick = e => handleFloorClick(e))
        : "null"
    )
  }, [
    selectedFavourite,
    activeFloor,
    bedroomCounts,
    activeBlock,
    activeApt,
    aspects,
    bathroomCounts
  ])

  return <BuildingElevationComponent buildingID={activeBlock} ref={svgref} />
}

//?  TODO -- STATIC */
export function StaticElevationSvgJsx({ isCard, activeBlock, floor }) {
  // const activeBlock = useStore(state => state.activeBlock)

  const bedroomCounts = useStore(state => state.bedroomCounts)
  const activeFloor = useStore(state => state.activeFloor)
  // const setActiveFloors = useStore(state => state.setActiveFloors)
  const activeApt = useStore(state => state.activeApt)
  const aspects = useStore(state => state.aspects)

  const svgref = useRef()
  const selectedFavourite = useStore(state => state.selectedFavourite)

  const returnFloorNumber = id => {
    return Number(id.split("_")[2])
  }

  const filterHabitable = arr => {
    return arr.filter(e => isHabitable(e.id))
  }

  const isHabitable = v => {
    return (
      blockInfo[activeBlock].habitableFloors.includes(returnFloorNumber(v)) ||
      isNaN(returnFloorNumber(v))
    )
  }

  useLayoutEffect(() => {
    if (svgref.current) {
      let floor_buttons = getNestedObject(
        svgref.current.children,
        "floor_button"
      )
      let floor_no = getNestedObject(svgref.current.children, "floor_no")
      let apt_no = getNestedObject(svgref.current.children, "apt_no")
      let apt_circle = getNestedObject(svgref.current.children, "apt_circle")
      let floor_circle = getNestedObject(
        svgref.current.children,
        "floor_circle"
      )
      //** ViewBox */

      // svgref.current.width.baseVal = "50%"

      //**Floor Circle */
      floor_circle.map(c => c.setAttribute("fill", colours.secondaryUI))
      //**Apartment Circle */
      apt_circle.map(c => c.setAttribute("fill", colours.primaryUILighter))
      apt_circle.map(c => (c.style.display = "none"))
      apt_circle = filterHabitable(apt_circle)
      // apt_circle.map(c => (c.style.display = ""))
      //**Apartment Number */
      apt_no.map(c => c.setAttribute("fill", colours.secondaryUI))
      apt_no.map(c => (c.style.cursor = "auto"))
      apt_no.map(c => (c.style.userSelect = "none"))
      apt_no.map(c => (c.style.display = "none"))
      //**floor number */
      floor_no.map(c => c.setAttribute("fill", colours.primaryUILight))
      floor_no.map(c => (c.style.cursor = "auto"))
      floor_no.map(c => (c.style.userSelect = "none"))
      //**Apartment Circle */
      floor_buttons.map(c => (c.style.display = "none"))
      floor_buttons = floor_buttons.filter(a => isHabitable(a.id))
      floor_buttons.map(c => (c.style.display = ""))
      floor_buttons.map(c => (c.style.cursor = "pointer"))
      floor_buttons.map(c => (c.style.userSelect = "none"))
      // ** Floor Buttons */
      floor_buttons.map(fb =>
        fb.setAttribute(
          "fill",
          floor === String(returnFloorNumber(fb.id))
            ? // floor.includes(String(returnFloorNumber(fb.id)))
              colours.primaryUILight
            : colours.primaryUILighter
        )
      )

      floor_buttons.map(fb =>
        fb.setAttribute(
          "opacity",
          isNaN(returnFloorNumber(fb.id))
            ? 0
            : floor === String(returnFloorNumber(fb.id))
            ? 0.7
            : 0
        )
      )
    }
  }, [
    activeFloor,
    bedroomCounts,
    activeBlock,
    activeApt,
    aspects,
    selectedFavourite
  ])

  // console.log("ACTIVEBLOCKLBOCKBOCK", activeBlock)

  return <BuildingElevationComponent buildingID={activeBlock} ref={svgref} />
}

export default SvgJSX
